// Shared with /auth/callback — used by Google and magic-link signup paths to
// hand a company name across the OAuth/passwordless redirect. Email/password
// signup creates the org server-side and doesn't touch this.
const PENDING_ORG_NAME_KEY = 'vector_pending_org_name';

export const stashPendingOrgName = (name: string): void => {
  try {
    localStorage.setItem(PENDING_ORG_NAME_KEY, name);
  } catch (_) {
    /* localStorage unavailable; the callback page falls back to a manual form */
  }
};

export const readPendingOrgName = (): string => {
  try {
    return localStorage.getItem(PENDING_ORG_NAME_KEY)?.trim() ?? '';
  } catch (_) {
    return '';
  }
};

export const clearPendingOrgName = (): void => {
  try {
    localStorage.removeItem(PENDING_ORG_NAME_KEY);
  } catch (_) {
    /* noop */
  }
};
